<template>
  <v-app-bar
    :clipped-left="clipped"
    :fixed="fixed"
    color="primary"
    dark
    app
    dense
  >
    <v-app-bar-nav-icon href="/">
      <v-icon>fa-star-and-crescent</v-icon>
    </v-app-bar-nav-icon>
    <v-spacer v-if="showMobileMenu" />
    <v-app-bar-title class="text-capitalize font-weight-bold headline">
      {{ $route.name ? $t(`pages.${$route.name}`) : title }}
    </v-app-bar-title>
    <v-spacer />
    <div v-if="!showMobileMenu">
      <v-tabs
        background-color="transparent"
        dark
        active-class="white--text"
        slider-color="white"
      >
        <template v-for="(item, i) in links">
          <v-tab v-if="!item.hidden" :key="i" :to="item.path" router exact>
            <v-icon small>fa-{{ item.icon }}</v-icon>
            <span class="mx-1">{{ $t("pages." + item.title) }}</span>
          </v-tab>
        </template>
      </v-tabs>
    </div>
    <v-app-bar-nav-icon @click="switchTheme()">
      <v-icon>{{ darkMode ? "fas" : "far" }} fa-moon</v-icon>
    </v-app-bar-nav-icon>
    <template v-if="$route.name === 'dikr'">
      <v-app-bar-nav-icon v-if="showMobileMenu" to="/">
        <v-icon>fa-angle-left</v-icon>
      </v-app-bar-nav-icon>
    </template>
  </v-app-bar>
</template>

<script>
import { navbar } from "@/mixins";

export default {
  mixins: [navbar],
};
</script>
